/*
 * GENERATED FILE -- do not edit by hand.
 * Regenerate with: npm run tokens:generate
 *
 * Kept in step with src/css/tokens/_color.css so the picker can never offer a
 * theme the stylesheet does not define.
 */
export const DEFAULT_THEME = 'material'

export const THEMES = [
  {
    id: 'material',
    label: 'Material',
    swatch: '#6750A4'
  },
  {
    id: 'stone',
    label: 'Stone',
    swatch: '#1d1d16'
  },
  {
    id: 'indigo',
    label: 'Indigo',
    swatch: '#3F51B5'
  },
  {
    id: 'emerald',
    label: 'Emerald',
    swatch: '#10B981'
  },
  {
    id: 'rose',
    label: 'Rose',
    swatch: '#E11D48'
  }
]
